import React from "react";
import { withStyles, Tooltip, IconButton } from "@material-ui/core";
import { GpsFixedOutlined, NotListedLocation } from "@material-ui/icons";

const styles = (theme) => ({
  locationIconStyle: {
    marginTop: "7px",
  },
  notListedLocationStyle: {
    color: theme.HeaderSelectedText,
    fontSize: "large",
  },
  gpsFixedOutlinedStyle: {
    color: theme.iconColor,
  },
  iconButtonStyle: {
    padding: "7px",
  },
});

const GeoCodeRenderer = (props) => {
  const { classes } = props;
  return (
    <Tooltip
      title={
        props.value ? "Geocoded Automatically" : "Click to Geocode"
      }
    >
      <IconButton
        aria-label="geocode"
        className={classes.iconButtonStyle}
        onClick={() => props.api.runCommand("openGeoCodeModel", props.data)}
      >
        {props.value ? (
          <GpsFixedOutlined className={classes.gpsFixedOutlinedStyle} />
        ) : (
          <NotListedLocation className={classes.notListedLocationStyle} />
        )}
      </IconButton>
    </Tooltip>
  );
};

export default withStyles(styles)(GeoCodeRenderer);
